import styled from "styled-components";

export const LayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  padding-top: 66px;
  background:
    radial-gradient(circle at 20% 20%, rgba(0, 247, 210, 0.08), transparent 40%),
    radial-gradient(circle at 80% 30%, rgba(92, 233, 255, 0.08), transparent 40%),
    #070a12;
  color: #e5e7eb;
  font-family: Inter, system-ui;
  
  @media (max-width: 768px) {
    padding-top: 30px;
  }
`;

export const MainArea = styled.div`
  flex: 1;
  padding: 50px;
  max-width: 65%;
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const Sidebar = styled.aside`
  width: 35%;
  padding: 40px;
  border-left: 1px solid rgba(0, 247, 210, 0.15);
  background: rgba(10, 15, 25, 0.95);
  backdrop-filter: blur(14px);
  position: sticky;
  top: 66px;
  height: calc(100vh - 66px);
  overflow-y: auto;
  
  @media (max-width: 768px) {
    top: 30px;
    height: calc(100vh - 30px);
    padding: 20px;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
`;

export const SlidePanel = styled.div`
  width: 420px;
  height: 100vh;
  background: #111522;
  padding: 30px;
  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.6);
  overflow-y: auto;
`;

export const SlideHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 10px;
  margin-top: 60px;
`;

export const HeaderBanner = styled.header`
  margin-bottom: 40px;
`;

export const MainTitle = styled.h1`
  font-size: 26px;
  background: linear-gradient(90deg, #00f7d2, #5ce9ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

export const Subtitle = styled.div`
  color: #94a3b8;
  margin-top: 6px;
`;

export const Card = styled.section`
  background: rgba(17, 21, 34, 0.8);
  padding: 25px;
  border-radius: 16px;
  margin-bottom: 25px;
  border: 1px solid rgba(0, 247, 210, 0.15);
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

export const SectionTitle = styled.span`
  font-weight: 600;
`;

export const Label = styled.label`
  font-size: 13px;
  color: #94a3b8;
  margin-bottom: 6px;
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  background: #0d1220;
  color: #fff;
  border: 1px solid #1f2937;
  outline: none;

  &:disabled {
    background: rgba(13, 18, 32, 0.5);
    color: rgba(255, 255, 255, 0.5);
    cursor: not-allowed;
    opacity: 0.7;
  }

  &[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(1);
    cursor: pointer;
    opacity: 1;
  }

  &[type="date"]:disabled::-webkit-calendar-picker-indicator {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ChipButton = styled.button`
  margin-right: 10px;
  padding: 6px 14px;
  border-radius: 20px;
  background: rgba(0, 247, 210, 0.1);
  border: 1px solid rgba(0, 247, 210, 0.3);
  color: #00f7d2;
  cursor: pointer;
`;

export const DropZone = styled.div`
  margin-top: 16px;
  padding: 30px 20px;
  border-radius: 16px;
  border: 2px dashed rgba(0, 247, 210, 0.4);
  background: rgba(0, 247, 210, 0.05);
  text-align: center;
  cursor: pointer;
  position: relative;
  transition: all 0.25s ease;
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
`;

export const HierarchyButton = styled.button`
  margin-bottom: 30px;
  padding: 10px 18px;
  border-radius: 10px;
  background: rgba(0, 247, 210, 0.1);
  border: 1px solid #00f7d2;
  color: #00f7d2;
  cursor: pointer;
`;

export const PreviewSection = styled.div`
  background: rgba(17, 21, 34, 0.8);
  padding: 20px;
  border-radius: 14px;
  border: 1px solid rgba(0, 247, 210, 0.2);
  margin-bottom: 30px;
`;

export const SectionHeader = styled.div`
  font-size: 14px;
  color: #5ce9ff;
  margin-bottom: 15px;
  font-weight: 600;
`;

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 8px;
  color: #cbd5e1;
`;

export const ProgressWrapper = styled.div`
  width: 100%;
  height: 8px;
  background: #1f2937;
  border-radius: 10px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #00f7d2, #5ce9ff);
`;

export const ProductSelectWrapper = styled.div`
  position: relative;
`;

export const ProductSelectDisplay = styled.button`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  background: #0d1220;
  color: #fff;
  border: 1px solid #1f2937;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const ProductSelectLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
`;

export const ProductThumb = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-color: #020617;
  flex-shrink: 0;
`;

export const ProductSelectName = styled.span`
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProductSelectDropdown = styled.div`
  position: absolute;
  z-index: 40;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 6px;
  max-height: 260px;
  overflow-y: auto;
  background: #020617;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.8);
`;

export const ProductOption = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: none;
  color: #e5e7eb;
  font-size: 13px;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: rgba(15, 23, 42, 0.9);
  }
`;

export const LotLoadingOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
`;
